import * as React from "react";
import { Box, Modal, Typography, Button, Divider, Avatar, IconButton, Tooltip } from "@mui/material";
import ModalHeader from "../../modals/ModalHeader";
import { apiErrorToast, okSuccessToast } from "../../utils/ToastUtil";
import { postJsonData } from "../../network/ApiController";
import ApiEndpoints from "../../network/ApiEndPoints";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import { Icon } from "@iconify/react";
import ModalFooter from "../../modals/ModalFooter";

// Modal style for Delete
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  bgcolor: "background.paper",
  boxShadow: 24,
  fontFamily: "Poppins",
  p: 2,
  height: "max-content",
  overflowY: "scroll",
};

const DeleteProjectModel = ({ open, handleClose, selectedProject, refresh }) => {
  const [request, setRequest] = React.useState(false);

  const deleteProject = (event) => {
    event.preventDefault();
    const deleteUrl = `${ApiEndpoints.DELETE_PROJECT}/${selectedProject.id}`;

    postJsonData(
      deleteUrl,  // Pass the URL with project id
      "",
      setRequest,

      (res) => {
        okSuccessToast(res.data.message); // Success message from backend
        handleClose();
        if (refresh) refresh(); // Refresh the list after deletion
      },
      (error) => {
        apiErrorToast("Error: ", error); // Show error toast
      }
    );
  };

  return (
    <Box sx={{ display: "grid", justifyContent: "center" }}>
     
      {/* Modal Structure */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="sm_modal">
          <ModalHeader
            title="Delete Project"
            handleClose={handleClose}
            subtitle="Are you sure you want to delete this project?"
          />
          <Box
            component="form"
            id="DeleteProject"
            noValidate
            autoComplete="off"
            onSubmit={deleteProject}
            sx={{
              display: "grid",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            {/* Display the project icon or placeholder */}
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Avatar
                src={selectedProject?.project_image}
                sx={{ width: 160, height: 160, objectFit: "cover", objectPosition: "100% 0" }}
                alt="project logo"
              />
            </Box>

            {/* Project details */}
            <Typography variant="h6" sx={{ mt: 2 }}>
              Are you sure?
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              You are about to delete the project: {selectedProject?.name}
            </Typography>

            {/* Modal footer with Yes/Cancel buttons */}
            <Box sx={{ mt: 3, display: "flex", justifyContent: "space-between" }}>
              {/* Cancel Button: Close the modal */}
              {/* <Button onClick={handleClose} variant="outlined">
                Cancel
              </Button>
              <Divider orientation="vertical" sx={{ height: 28 }} /> */}
              {/* Delete Button: Confirm deletion */}
              {/* <Button
                onClick={deleteProject}
                variant="contained"
                color="error"
                sx={{ width: "100px" }}
                disabled={request}
              >
                Delete
              </Button> */}
     <ModalFooter form="DeleteProject" request={request} btn="Delete Project" />
              
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default DeleteProjectModel;
